import gql from 'graphql-tag';

export const all = gql`query getClients {
    clients {
        id
        name
        
        currency {
            id
            name
            isoCode
            symbol
        }
        
        address
        gitCode
        phone
        fax
        email
        vatRate
        comments
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/client.js